<template>
  <div class="loader loader-general" v-if="loader">
    <div class="loader-circle"></div>
  </div>
</template>

<script>

  import {mapState} from 'vuex'

  export default {
    name: "LoaderGeneral",
    computed: {
      ...mapState({
        loader: state => state.loader
      })
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Partials/Loader/General.vue